








































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import moment from "moment";
import BindableDatePicker from "../BindableDatePicker.vue";
import BindableTimePicker from "../BindableTimePicker.vue";

export interface TestDetail {
  testId: string;
  testDate: moment.Moment;
  testTime: moment.Moment;
  testWeather: string;
  testExcavationMethod: string;
}

@Component({
  components: {
    BindableDatePicker,
    BindableTimePicker
  }
})
export default class TestDetails extends Vue {
  private get testDate() {
    if (this.internalTestDetail.testDate) {
      return this.internalTestDetail.testDate.format("DD/MM/YYYY");
    } else {
      return "";
    }
  }

  private get isoDate() {
    return this.internalTestDetail.testDate.toISOString();
  }

  @Prop({
    default: {
      testId: "",
      testDate: "",
      testTime: "",
      testWeather: "Dry",
      testExcavationMethod: "Hand Tools"
    }
  })
  public value!: TestDetail;
  private internalTestDetail: TestDetail = {
    testId: "",
    testDate: moment(),
    testTime: moment(),
    testWeather: "",
    testExcavationMethod: ""
  };
  private weatherChoices: string[] = [
    "Snowing",
    "Raining",
    "Overcast",
    "Clear",
    "Sunny",
    "Foggy",
    "Dry",
    "Wet",
    "N/A"
  ];
  private excavationChoices: string[] = ["Hand Tools", "Mechanical Auger"];
  private showDateMenu: boolean = false;
  private showTimeMenu: boolean = false;

  @Watch("value")
  protected updateInternalData() {
    this.internalTestDetail = this.value;
    this.internalTestDetail.testTime = this.internalTestDetail.testDate
      .set("hours", this.internalTestDetail.testTime.hours())
      .set("minutes", this.internalTestDetail.testTime.minutes());
  }

  protected mounted() {
    this.updateInternalData();
  }

  @Watch("internalTestDetail", { deep: true })
  private emitInput() {
    this.$emit("input", this.internalTestDetail);
  }
}
